import React, { useEffect, useState } from 'react';
import api from '~/services/api';
import { Label, Input, Select, TextArea } from '~/componentes/CustomForm';

import { Container } from './styles';
import CustomScrollBar from '~/componentes/CustomScrollBar';
import { Materialize } from '~/styles/materializeGrid';
import { SLModalFooter } from '~/pages/Sistema/componentes/SistemaList';
import ShowConfirmacao from '~/utils/ShowConfirmacao';

function CreateEditContent({ mountedData }) {
  const [clientes, setClientes] = useState([]);
  const [cliente, setCliente] = useState({});
  const [produtos, setProdutos] = useState([]);
  const [projetos, setProjetos] = useState([]);
  const [produto, setProduto] = useState({});

  const [ativo, setAtivo] = useState(
    !mountedData ? 'true' : mountedData?.ativo ? 'true' : 'false',
  );

  useEffect(() => {
    api.get("/signed/empresa/gestorprojeto/cliente/clientes", { params: { ativo: 1 } })
      .then(response => setClientes(response.data));

    api.get("/signed/empresa/gestorprojeto/projetos", { params: { tipoProjeto: "S" } })
      .then(response => setProjetos(response.data));

  }, []);

  useEffect(() => {
    api.get("/signed/empresa/gestorprojeto/gerencia/produtos", { params: { ativo: 1 } }).then((r) => setProdutos(r?.data));

  }, []);

  async function handleSubmit(data, options) {
    const { closeReload } = options || {};

    return ShowConfirmacao(
      async () => {
        let thisData = {
          ...data,
          ...(mountedData?.id ? { id: mountedData?.id } : {}),
          ativo: ativo === 'true' ? true : false,
        };
        let response;
        if (mountedData?.id)
          response = await api.put(
            '/signed/empresa/suporte/contrato',
            thisData,
          );
        else
          response = await api.post(
            '/signed/empresa/suporte/contrato',
            thisData,
          );

        if (response?.status === 200) {
          closeReload && closeReload();
        }
        return response;
      },
      {
        errorModal: {
          defaultMessage: `Ocorreu um erro ao ${mountedData?.id ? 'atualizar' : 'cadastrar'
            } esse Contrato, por favor, tente novamente mais tarde.`,
        },
        message: `Tem certeza que deseja ${mountedData?.id ? 'atualizar' : 'cadastrar'
          } esse Contrato?`,
        successModal: `Contrato ${mountedData?.id ? 'atualizado' : 'cadastrado'
          } com sucesso!`,
      },
    );
  }

  return (
    <Container onSubmit={handleSubmit} defaultScroll={true}>
      <Materialize className="materialize">
        <div className="row header">
          <p className="h-descricao">
            Preencha as informações corretamente, e se atente ao (*) pois são
            campos obrigatórios
          </p>
        </div>
        <div className="row">
          <Label title="Cliente *" className="col s12 m6 l4">
            <Select
              required="true"
              isString
              list={{
                list: clientes,
                value: 'id',
                label: 'nomeFantasia',
              }}
              name="idCliente"
              firstOption
              defaultValue={mountedData?.idCliente}
              onChange={e => {
                const v = e.currentTarget.value || 0;
                const cliente = clientes?.find(e => e?.id == parseInt(v));
                setCliente(cliente || {});
              }}
            />
          </Label>
          <Label title="Início *" className="col s12 m6 l2">
            <Input
              type="date"
              name="dataInicio"
              required="true"
              defaultValue={mountedData?.dataInicio}
            />
          </Label>
          <Label title="Vencimento *" className="col s12 m6 l2">
            <Input
              type="date"
              name="dataVencimento"
              required="true"
              defaultValue={mountedData?.dataVencimento}
            />
          </Label>
          <Label title="Período *" className="col s12 m6 l2">
            <Select
              required="true"
              isString
              list={{
                list: [
                  { id: 'M', titulo: 'Mensal' },
                  { id: 'B', titulo: 'Bimestral' },
                  { id: 'S', titulo: 'Semestral' },
                ],
                value: 'id',
                label: 'titulo',
              }}
              name="ativo"
              defaultValue={mountedData?.ativo?.toString()}
              onChange={e => {
                const v = e.currentTarget.value || 'true';
                setAtivo(v);
              }}
            />
          </Label>
          <Label title="Ativo *" className="col s12 m6 l2">
            <Select
              required="true"
              isString
              list={{
                list: [
                  { id: 'true', titulo: 'Sim' },
                  { id: 'false', titulo: 'Não' },
                ],
                value: 'id',
                label: 'titulo',
              }}
              name="ativo"
              defaultValue={mountedData?.ativo?.toString()}
              onChange={e => {
                const v = e.currentTarget.value || 'true';
                setAtivo(v);
              }}
            />
          </Label>
        </div>
        <div className="row">
          <Label title="Produto *" className="col s12 m6 l2">
            <Select
              required="true"
              isString
              list={{ list: produtos, value: "id", label: "titulo" }}
              name="idProduto"
              firstOption
              defaultValue={mountedData?.idProduto}
            />
          </Label>
          <Label title="Tipo de Contrato" className="col s12 m6 l2">
            <Select
              isString
              list={{
                list: [
                  { id: 'S', titulo: 'Suporte' },
                  { id: 'B', titulo: 'Banco de Horas' },
                ],
                value: 'id',
                label: 'titulo',
              }}
              name="tipoContrato"
              defaultValue={mountedData?.tipoContrato}
            />
          </Label>
          <Label title="Total de Horas" className="col s12 m6 l2">
            <Input type="number"
              name="quantidadeHoras"
              defaultValue={mountedData?.quantidadeHoras} />
          </Label>
          <Label title="Id MoviDesk" className="col s12 m6 l2">
            <Input
              name="idMoviDesk"
              defaultValue={mountedData?.idMoviDesk} />
          </Label>
          <Label title="Vincular a um Projeto" className="col s12 m6 l4">
            <Select
              isString
              list={{ list: projetos, value: "id", label: "titulo" }}
              name="idProjeto"
              firstOption
              defaultValue={mountedData?.idProjeto}
            />
          </Label>
        </div>
        <div className="row">
          <Label title="Descrição" className="col s12 m12 l12">
            <TextArea name="descricaoServico" />
          </Label>
        </div>
        {/* <div className="fundo">
          <p className="titulo">Obrigações</p>
        </div>
        <div className="row">
          <Label title="Obrigações Contratante" className="col s12 m6 l6">
            <TextArea
              name="obrigacoes"
            />
          </Label>
          <Label title="Obrigações Contratada" className="col s12 m6 l6">
            <TextArea
              name="obrigacoes"
            />
          </Label>
        </div> */}
      </Materialize>
    </Container>
  );
}

export default CreateEditContent;
